import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import SMSStatusCellContent from "../components/SMSStatusCellContent";
import { MessageTemplateActions } from "../../../../../../types/MessageTemplateEnums";

function smsLateStatus({ width, onResize, language }: Column.Options) {
	return base(
		ColumnId.SMSLateStatus,
		(item) => (
			<SMSStatusCellContent
				item={item}
				type={MessageTemplateActions.LATE}
				language={language}
			/>
		),
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default smsLateStatus;
